import { Box, Button, Typography } from '@mui/material';

import { useAuth } from '../../providers/Auth';

export const AccountMenu = (): JSX.Element | null => {
  const { user, signout } = useAuth();

  if (!user) {
    return null;
  }

  const { profile } = user;
  const display = profile.preferred_username || profile.name || profile.sub;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Typography variant="body2" color="text.secondary" noWrap>
        {display}
      </Typography>
      <Button size="small" variant="outlined" onClick={() => signout()}>
        Sign out
      </Button>
    </Box>
  );
};

export default AccountMenu;
